import { useState, useEffect } from 'react';
import { ConsoleLogger } from '@nextgen-web-framework/core';
import { FulfillmentApi } from '@commerce-fulfillment-webcomponents/sdk';
import { useNextgenRouter } from '@nextgen-web-framework/all';
import {
  useCurrentLocation,
  transformFulfillmentLocations,
  type AmwayShopCollections,
  type IShopsOptions,
} from '@commerce-webcomponents/ui';

const useShopFetchLocations = () => {
  const baseUrl = ApiConfigService.getBaseUrl();
  const [shopLocations, setShopLocations] = useState<IShopsOptions[]>();
  const [isLocationAccessAllowed, setIsLocationAccessAllowed] = useState(false);
  const { lat, lng, error } = useCurrentLocation();
  const [isFetchingShopDetails, setIsFetchingShopDetails] = useState(true);
  const router = useNextgenRouter();

  useEffect(() => {
    const params: { fulfillmentType: string; latitude?: string; longitude?: string } = {
      fulfillmentType: 'bopis',
    };
    if (lat && lng) {
      setIsLocationAccessAllowed(true);
      params.latitude = lat.toString();
      params.longitude = lng.toString();
    }
    const getShops = async () => {
      let data: AmwayShopCollections;
      try {
        setIsFetchingShopDetails(true);
        data = (await FulfillmentApi.getServiceLocations({
          baseUrl,
          params,
        })) as AmwayShopCollections;
        if (data) {
          setShopLocations(transformFulfillmentLocations(data) as IShopsOptions[]);
        }
        setIsFetchingShopDetails(false);
      } catch (shopDataError) {
        ConsoleLogger.info('error', shopDataError);
        setIsFetchingShopDetails(false);
      }
    };
    if (lat || lng || error) {
      getShops();
    }
  }, [lat, lng, error, router.params?.locale]);

  return { shopLocations, isFetchingShopDetails, isLocationAccessAllowed };
};

export default useShopFetchLocations;
